<template>
    <div class="order-list">
        <van-icon name="wap-home-o" class="homeflash" @click="goback" />
        <Empty description="暂无数据" v-if="List.length===0" />
        <List v-else class="order-record"  v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad">
            <div class="order-record-body"  v-for="(item,index) in List" :key="index" @click="goOrderDetail(item.id)">
                <div class="order-record-body-header">
                    <span>订单编号: {{item.orderno}}</span>
                </div>
                <div class="order-record-body-content">
                    <Card
                            :num="item.skuInfo.amount"
                            :desc="item.skuInfo.gpname"
                            :title="item.skuInfo.gname"
                            :thumb="item.skuInfo.gpimgurl"
                    >
                        <div slot="price" class="price van-submit-bar__price">
                            <img :src="require('assets/img/common/coin.png')" class="coin" alt="">
                            <span class="price_num van-submit-bar__price van-submit-bar__price--integer">{{item.skuInfo.point}}</span>
                            <template v-if="item.skuInfo.price*1>0">
                                <span class="price-symbol"> + </span><span class="">¥</span> <span
                                    class=" van-submit-bar__price van-submit-bar__price--integer">{{item.skuInfo.price}}</span>
                            </template>
                        </div>

                    </Card>
                </div>
                <div class="order-record-body-footer">
                    兑换时间: {{item.paytime}}
                </div>
            </div>
        </List>
    </div>
        
</template>
<script>
    import {List,Card,Empty} from 'vant'
    import './index.less'
    export default {
        name: "myOrders",
        components: {
            List,
            Empty,
            Card
        },
        data() {
            return {
                page:1,
                List: [],
                finished:false,
                loading:false
            }
        },
        methods: {
            goback() {
                this.$router.push({name:'index'})
            },
            goOrderDetail:function(e){
                this.$router.push({name:'orderDetail',params:{'orderid':e}})
            },
            onLoad(){
              this.getList()
            },
            getList() {
                if(this.finished) return;
                this.$api.user.myOrder({page:this.page}).then((res) => {
                    if (res.status * 1 === 200) {
                        this.List = this.List.concat(res.data.list)
                        if(res.data.pages*1>this.page){
                            this.page++
                        }else{
                            this.finished   =   true
                        }
                    }
                    this.loading = false
                })
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.getList();
            })
        }
    }
</script>
